<template>
  <div class="contents">
    <MobilePlanDivider />

    <div
      class="grid grid-cols-1 gap-y-16 p-16 lg:grid-cols-[max-content,auto,max(18.5rem)] lg:gap-y-0 lg:p-32"
    >
      <div class="flex w-full flex-row">
        <MobilePlanImage
          :image="logoUrl"
          :title="`${bundledMobilePlan.partnerProvider}-logo-img`"
        />

        <MobilePlanContent
          class="ml-8 lg:ml-0 lg:hidden"
          :contract-commitment-label="bundledMobilePlan.contractCommitmentLabel"
          :mobile-plan-offer-label="bundledMobilePlan.mobilePlanOfferLabel"
          :price-label="bundledMobilePlan.priceLabel"
          :price-sub-label="bundledMobilePlan.priceSubLabel"
          :state="bundledMobilePlan.state"
        />
      </div>

      <div
        class="hidden lg:flex lg:size-full lg:flex-col lg:justify-start lg:py-0 lg:pl-24 lg:pr-56"
      >
        <MobilePlanContent
          class="lg:mb-24 lg:mt-32"
          :contract-commitment-label="bundledMobilePlan.contractCommitmentLabel"
          :mobile-plan-offer-label="bundledMobilePlan.mobilePlanOfferLabel"
          :price-label="bundledMobilePlan.priceLabel"
          :price-sub-label="bundledMobilePlan.priceSubLabel"
          :state="bundledMobilePlan.state"
        />
      </div>

      <div class="flex h-full flex-col justify-center">
        <MobilePlanActions
          :mobile-plan-actions="bundledMobilePlan.actions"
          :orderline-id
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { MobilePlanProps } from './MobilePlan.types'
import MobilePlanActions from './components/MobilePlanActions/MobilePlanActions.vue'
import MobilePlanContent from './components/MobilePlanContent/MobilePlanContent.vue'
import MobilePlanDivider from './components/MobilePlanDivider/MobilePlanDivider.vue'
import MobilePlanImage from './components/MobilePlanImage/MobilePlanImage.vue'

defineProps<MobilePlanProps>()
</script>
